<template>
  <div>
    <v-layout :class="justify ? 'justify-' + justify : ''">
      <h2 class="primary--text text-uppercase textoAjustado" :class="align ? 'text-xs-' + align : ''"><slot></slot></h2>
    </v-layout>
    <v-layout v-if="divider" row align-center justify-center mb-3>
      <v-divider class="dividerTitle primary"></v-divider>
    </v-layout>
  </div>
</template>

<script>
export default {
  name: 'o-big-title',
  props: {
    align: {
      type: String,
      default: 'center'
    },
    justify: {
      type: String,
      default: 'center'
    },
    divider: {
      type: Boolean,
      default: true
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/generic/titulos/OBigTitle.vue